import styled from 'styled-components'

import RoundedButton from 'components/RoundedButton'
import { ReactComponent as checkCircleOutline } from 'resources/images/icons/checkCircleOutline.svg'
import { COLOURS } from 'resources'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`

export const SectionText = styled.div`
  font-size: 14px;
  color: ${COLOURS.neutralBlack};
`

export const SectionBoldText = styled(SectionText)`
  font-size: 18px;
  font-weight: bold;
`

export const PledgeButton = styled(RoundedButton).attrs({
  withArrow: true,
})`
  margin-top: 20px;
`

export const DeleteButton = styled(RoundedButton).attrs({
  variant: 'transparentRed',
})`
  width: 100%;
  margin-top: 5px;
`

export const CompletedRequestContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`

export const SuccessIcon = styled(checkCircleOutline)`
  width: 14px;
  height: 14px;
  padding-right: 5px;

  path {
    fill: ${COLOURS.systemGreen1};
  }
`

export const ErrorMessage = styled.div`
  font-size: 14px;
  color: ${COLOURS.secondaryRed1};
  margin-top: 10px;
`
